__turbopack_context__.v({
  "barGraphInfoIcon": "stream-stats-content-module-scss-module__nMT85a__barGraphInfoIcon",
  "chartBody": "stream-stats-content-module-scss-module__nMT85a__chartBody",
  "headerDayLabel": "stream-stats-content-module-scss-module__nMT85a__headerDayLabel",
  "headerDayValue": "stream-stats-content-module-scss-module__nMT85a__headerDayValue",
  "infoButton": "stream-stats-content-module-scss-module__nMT85a__infoButton",
  "infoIcon": "stream-stats-content-module-scss-module__nMT85a__infoIcon",
  "monthTotal": "stream-stats-content-module-scss-module__nMT85a__monthTotal",
  "monthTotalWrap": "stream-stats-content-module-scss-module__nMT85a__monthTotalWrap",
  "monthTotalWrapHidden": "stream-stats-content-module-scss-module__nMT85a__monthTotalWrapHidden",
  "monthTotalWrapVisible": "stream-stats-content-module-scss-module__nMT85a__monthTotalWrapVisible",
  "page": "stream-stats-content-module-scss-module__nMT85a__page",
  "progressChartCard": "stream-stats-content-module-scss-module__nMT85a__progressChartCard",
  "progressChartCell": "stream-stats-content-module-scss-module__nMT85a__progressChartCell",
  "progressGrid": "stream-stats-content-module-scss-module__nMT85a__progressGrid",
  "sectionFullWidth": "stream-stats-content-module-scss-module__nMT85a__sectionFullWidth",
  "statsGrid": "stream-stats-content-module-scss-module__nMT85a__statsGrid",
  "statsRangePicker": "stream-stats-content-module-scss-module__nMT85a__statsRangePicker",
  "streamStatCard": "stream-stats-content-module-scss-module__nMT85a__streamStatCard",
});
